import { Paper, Stack, Tabs } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import { NavigationWrapper } from '../components/navigation/NavigationWrapper';
import { PaymentSetupModal } from '../components/modals/PaymentSetupModal';
import { useApp } from '../context/AppContext';
import { primaryColor } from '../constants/theme';
import { AddAvailabilityTab } from '../components/topics/AddAvailabilityTab';
import { ManageAvailabilityTab } from '../components/topics/ManageAvailabilityTab';
import { TopicsTabPanel } from '../components/topics/TopicsTabPanel';

export const Availability = () => {
  const { profile } = useApp();
  const canCreateAvailability = Boolean(profile?.paymentAccountChargesEnabled);
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);

  const [activeTab, setActiveTab] = useState<string | null>('add');
  const [manageRefreshKey, setManageRefreshKey] = useState(0);

  useEffect(() => {
    if (profile && !canCreateAvailability) {
      openModal();
    }
  }, [profile, canCreateAvailability, openModal]);

  return (
    <NavigationWrapper>
      <PaymentSetupModal opened={modalOpened} onClose={closeModal} />
      <Stack align="center">
        <Paper
          maw={1200}
          shadow="md"
          p={{ base: 'md', sm: 'lg' }}
          radius="md"
          withBorder
          w="100%"
        >
          <Tabs value={activeTab} onChange={setActiveTab} color={primaryColor} variant="pills">
            <Tabs.List
              style={(theme) => ({
                border: `1px solid ${theme.colors.gray[3]}`,
                borderRadius: theme.radius.sm,
                padding: 2,
                gap: 0,
              })}
            >
              <Tabs.Tab value="add" style={{ flex: 1, borderRadius: 'var(--mantine-radius-sm)' }}>
                Add
              </Tabs.Tab>
              <Tabs.Tab value="manage" style={{ flex: 1, borderRadius: 'var(--mantine-radius-sm)' }}>
                Manage
              </Tabs.Tab>
              <Tabs.Tab value="topics" style={{ flex: 1, borderRadius: 'var(--mantine-radius-sm)' }}>
                Topics
              </Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="add" pt="md">
              {canCreateAvailability && <AddAvailabilityTab onSuccess={() => { setManageRefreshKey((k) => k + 1); setActiveTab('manage'); }} />}
            </Tabs.Panel>

            <Tabs.Panel value="manage" pt="md">
              {canCreateAvailability && <ManageAvailabilityTab refreshKey={manageRefreshKey} />}
            </Tabs.Panel>

            <Tabs.Panel value="topics" pt="md">
              {canCreateAvailability && <TopicsTabPanel />}
            </Tabs.Panel>
          </Tabs>
        </Paper>
      </Stack>
    </NavigationWrapper>
  );
};
